import { render, staticRenderFns } from "./down.vue?vue&type=template&id=b43161b4&scoped=true&"
var script = {}
import style0 from "./down.vue?vue&type=style&index=0&id=b43161b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43161b4",
  null
  
)

export default component.exports